import { createDashHttpClient } from '@/apis/dash.http';
import { env } from '@/env';

// Bluesky account info lives in auth_db.bluesky_account table for now
// until the dedicated backend is created
export const http = createDashHttpClient(env.authApiUrl);

export async function getBlueskyAccount({ brandId }, config = {}) {
  return http.get(`/brands/${brandId}/bluesky/handle`, config);
}

export async function getBlueskyAccountAllBrands({ brandIds }, config = {}) {
  return http.put(`/brands/bluesky/handle`, { brand_ids: brandIds }, config);
}
